import { orderBy } from "lodash";
import { SERVER_URLS } from "../../appConstants";
import { getToken } from "../authentication";

export const getAllLeadOrders = ({ orderBy, orderType, searchQuery, pageSize, pageNumber, fromDate, toDate, userRole, userId,dspId }) => {
    return new Promise(async (resolve, reject) => {
        try {
            let data;
            const token = getToken();
            console.log(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/customerSuccessEngineer/leadOrders`)
            const response = await fetch(
                `${SERVER_URLS.BACKEND_SERVER}/aggregator/request/leadOrders?pageNumber=${pageNumber || ""}&pageSize=${pageSize || ""}&searchQuery=${encodeURIComponent(searchQuery || "")}` +
                `${orderBy ? `&orderBy=${orderBy}` : ""}` +
                `${orderType ? `&orderType=${orderType}` : ""}` +
                `${fromDate ? `&fromDate=${new Date(fromDate).toISOString()}` : ""}` +
                `${toDate ? `&toDate=${new Date(toDate).toISOString()}` : ""}` +
                `${userRole ? `&userRole=${userRole}` : ""}` +
                `${userId ? `&userId=${userId}` : ""}` +
                `${dspId ? `&dspId=${dspId}` : ""}` ,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 204) {
                resolve({ orders: [] });
            } else {
                data = await response.json();
            }
            if (response.ok && response.status === 200) {
                resolve({ orders: data.orders });
            } else if (response.status === 204) {
                resolve({ requests: [] });
            } else {
                reject(data?.message || "Something went wrong while lead orders.");
            }
        } catch (error) {
            reject("Something went wrong while getting lead orders.");
        }
    });
}